var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMagicWand = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 77.431l-3.869-3.875L60.4 16.538l3.869 3.868L7.25 77.431z",
    fill: "url(#prefix__prefix__paint0_linear_1906_387)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.025 17.788c-1.406-1.407-2.619-1.25-2.619-1.25L50.331 26.613c.594-.132 1.638.375 2.569 1.3.925.924 1.431 1.968 1.3 2.568l10.075-10.075c-.006 0 .156-1.206-1.25-2.618z",
    fill: "url(#prefix__prefix__paint1_linear_1906_387)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.188 64.625c-1.407-1.406-2.62-1.25-2.62-1.25l-10.105 10.1c.593-.131 1.668.35 2.6 1.275.925.925 1.406 2.006 1.275 2.6l10.1-10.106s.156-1.213-1.25-2.619z",
    fill: "url(#prefix__prefix__paint2_linear_1906_387)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31 77.372c.474-.473-.009-1.724-1.078-2.793-1.07-1.069-2.32-1.552-2.793-1.078-.474.474.01 1.724 1.078 2.793 1.07 1.069 2.32 1.552 2.793 1.078z",
    fill: "#9E9E9E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M60.388 16.55L17.925 59.019c-.475.475.006 1.725 1.075 2.787 1.069 1.069 2.319 1.55 2.788 1.075l42.468-42.468s.263-1.175-1.237-2.632c-1.5-1.456-2.631-1.231-2.631-1.231z",
    fill: "url(#prefix__prefix__paint3_linear_1906_387)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M45.869 31.069L3.406 73.537c-.475.475.006 1.725 1.075 2.788C5.55 77.394 6.8 77.875 7.27 77.4l42.475-42.463s.262-1.174-1.238-2.63c-1.506-1.45-2.637-1.238-2.637-1.238z",
    fill: "url(#prefix__prefix__paint4_linear_1906_387)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.231 11.762l3.738-3.724c.206-.207.562-.038.531.256l-.481 4.368a.31.31 0 00.275.344l5.35.638a.31.31 0 01.087.594l-5.575 2.493a.317.317 0 00-.169.2l-1.612 5.531a.308.308 0 01-.569.063l-2.493-4.531a.318.318 0 00-.3-.163l-4.788.388a.31.31 0 01-.244-.532l3.175-3.093a.316.316 0 00.069-.35L38.544 10.4a.311.311 0 01.419-.406l3.93 1.837c.107.05.245.025.338-.069z",
    fill: "url(#prefix__prefix__paint5_radial_1906_387)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.806 39.538l2.963 1.368a.21.21 0 00.225-.025l2.968-2.243c.157-.12.37.006.357.193l-.282 3.688a.217.217 0 00.107.206l2.831 1.75c.169.106.125.369-.075.406l-3.55.731a.221.221 0 00-.175.17l-.756 3.343c-.044.2-.313.237-.413.056L59.431 46.3a.225.225 0 00-.2-.119l-3.725.119c-.194.006-.3-.219-.181-.369l2.4-2.868a.221.221 0 00.038-.232L56.5 39.82c-.069-.181.125-.369.306-.282z",
    fill: "url(#prefix__prefix__paint6_radial_1906_387)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.031 7.281L74.3 4.944c.263-.119.494.143.356.393l-2.606 4.8a.29.29 0 00.031.338l5.644 5.475c.169.175.025.488-.231.5l-6.925-1.219a.327.327 0 00-.263.169l-3.644 6.669c-.137.244-.487.219-.543-.038l-.713-6.493a.273.273 0 00-.244-.207l-5.718-.931c-.244-.019-.338-.313-.15-.494l4.781-3.675a.308.308 0 00.094-.256l-.856-7.238c-.026-.275.318-.456.512-.268l4.888 4.762a.307.307 0 00.318.05z",
    fill: "url(#prefix__prefix__paint7_radial_1906_387)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.681 16.794c-2.337.6-4.706 1.119-7.125 1.319-2.419.218-4.875.043-7.262-.388-2.388-.444-4.732-1-7.094-1.438a105.244 105.244 0 00-7.125-1.062c-1.194-.137-2.394-.237-3.588-.356-1.168-.113-2.325-.082-3.425.175-1.08.275-2.087.793-2.737 1.643-.656.838-.969 1.925-.969 3.044-.012 2.256.894 4.506 2.044 6.538 1.156 2.044 2.675 3.9 4.194 5.756 3.025 3.725 6.293 7.269 9.537 10.837 1.625 1.788 3.25 3.57 4.85 5.382a103.87 103.87 0 014.656 5.569c1.494 1.906 2.913 3.9 4.07 6.062.287.525.605 1.106.7 1.806.03.357-.007.75-.207 1.1-.2.35-.531.569-.85.713-.656.262-1.306.281-1.931.25a11.234 11.234 0 01-1.838-.275c-2.387-.581-4.619-1.575-6.769-2.694a53.947 53.947 0 01-3.156-1.794 70.068 70.068 0 01-3.019-2c2.05 1.275 4.15 2.463 6.32 3.494 2.168 1.025 4.424 1.919 6.743 2.387.581.107 1.162.194 1.737.213.575.019 1.157-.031 1.62-.231.224-.107.412-.244.505-.431.094-.182.12-.413.094-.657-.075-.5-.344-1-.65-1.519-1.169-2.062-2.6-3.987-4.125-5.837-6.1-7.4-13.05-14.125-19.25-21.587-1.519-1.882-3.056-3.794-4.262-5.963-1.188-2.15-2.17-4.538-2.138-7.144.013-1.287.388-2.643 1.238-3.706.843-1.081 2.106-1.706 3.35-2.006 1.256-.275 2.543-.306 3.775-.163 1.2.15 2.406.275 3.606.444 2.4.338 4.787.75 7.156 1.244 2.369.5 4.713 1.1 7.056 1.606 2.338.512 4.725.781 7.125.656 2.394-.112 4.775-.518 7.144-.987z",
    fill: "#FDD835"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.862 22.275c-7.03 1.638-15.1-3.125-22.55-2.287-2.843.375-4.012 3.774-1.28 9.162 5.362 9.231 13.187 14.681 16.074 18.063-3.881-2.175-11.856-7.907-17.4-13.3-8.343-8-6.8-18 .938-17.97 2.594-.25 7.612 1 9.712 1.77 2.069.83 9.113 3.9 14.506 4.562z",
    fill: "url(#prefix__prefix__paint8_radial_1906_387)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__prefix__paint0_linear_1906_387",
    x1: 31.89,
    y1: 45.048,
    x2: 35.76,
    y2: 48.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424242"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__prefix__paint1_linear_1906_387",
    x1: 56.05,
    y1: 21.574,
    x2: 60.291,
    y2: 25.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__prefix__paint2_linear_1906_387",
    x1: 9.196,
    y1: 68.422,
    x2: 13.447,
    y2: 72.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__prefix__paint3_linear_1906_387",
    x1: 43.241,
    y1: 37.567,
    x2: 64.865,
    y2: 15.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FADA80",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADA80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__prefix__paint4_linear_1906_387",
    x1: -1.069,
    y1: 81.877,
    x2: 13.896,
    y2: 66.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A237E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#1D2A87",
    stopOpacity: 0.814
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#243DA0",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#2F5CC7",
    stopOpacity: 0.127
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3367D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix__prefix__paint5_radial_1906_387",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(2.144 -361.389 1288.413) scale(9.24)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC02D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix__prefix__paint6_radial_1906_387",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-20.089 144.802 -154.614) scale(7.42688)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC02D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix__prefix__paint7_radial_1906_387",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(104.711 29.42 32.182) scale(10.0176 10.829)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#FFEB3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC02D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix__prefix__paint8_radial_1906_387",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(50.37343 29.9054 -17.9222 30.18862 58.477 43.805)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE58",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD835"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMagicWand);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/magic-wand.db59e25531aad493963349c572e896bc.svg";